import type { Sale, SaleLine } from "../api/types";
import { hasUnknown } from "./unknownCost";

/**
 * G-151 — the web's copy of the server's one rule (`ACTIVE_SALE_WHERE`,
 * src/modules/sales/sale-status.ts): an undone (VOIDED) sale counts as no
 * money. Sales records lists undone sales, marked (owner ruling 2026-10-13).
 *
 * G-169 (WO-D): the sums that lived here (`sumSales`) are the server's now —
 * `GET /sales/totals` and `/sales/me/totals` (`sale-period-totals.ts`); the
 * browser only reads the flags below off each row.
 */
export function saleCountsAsMoney(sale: Pick<Sale, "status">): boolean {
  return sale.status === "ACTIVE";
}

/**
 * WO-B (G-139, OD-198): is the whole cost of this sale known? When a line drew
 * on stock of unknown cost, `totalCogsEur` is the known part and the margin
 * counts the rest as free. Absent (an older answer) reads as known.
 */
export function saleCostIsKnown(sale: Pick<Sale, "unknownCostLineCount">): boolean {
  return !hasUnknown(sale.unknownCostLineCount);
}

/** The same for one line: no unit of it is of unknown cost. */
export function lineCostIsKnown(line: Pick<SaleLine, "unknownCostQty">): boolean {
  return !hasUnknown(line.unknownCostQty);
}
